const defaultRender = (value) => (value ? value : '--');

const columns = [
    {
        title: 'Organizer',
        dataIndex: 'organizer',
        render: defaultRender,
    },
    {
        title: 'Amount',
        dataIndex: 'amount',
        render: defaultRender,
    },
    {
        title: 'Created Date',
        dataIndex: 'created_at',
        render: defaultRender,
    },
    {
        title: 'Status',
        dataIndex: 'status',
        render: defaultRender,
    },
    {
        title: 'Action',
        dataIndex: 'action',
        render: defaultRender,
    },
];

export default columns;